import React from "react";
import { SECTIONS } from "../../../../constants/sections";
import { Button } from "../../../atoms/button";
import { Flex } from "../../../atoms/flex";
import { Text } from "../../../atoms/text";
import { Section } from "../../../atoms/section";
import { Wave } from "../../../atoms/wave";
import { Header } from "../../../molecules/header";
import "./contact.css";
import { CALL_TO_ROBIN, MAIL_TO_ROBIN } from "../../../../constants/contact";
import { useStore } from "../../../../store";

/**
 * Contact section
 */
export const Contact = () => {
  const mailTo = () => {
    window.location.assign(MAIL_TO_ROBIN);
  };

  const callTo = () => {
    window.location.assign(CALL_TO_ROBIN);
  };

  const { loading } = useStore();

  return (
    <>
      <Wave className="fill-gray" variant={2} />
      <Section className="bg-gray small-padding" id={SECTIONS.CONTACT} wave>
        <Header
          title={SECTIONS.CONTACT}
          className="contact-header"
          loading={loading}
        />
        <Flex className="contact-content">
          <Text size={22} className="contact-text">
            Tveka inte på att höra av er med frågor eller kommentarer. Vårt mål
            är att skapa en produkt som är så bra som möjligt för era behov,
            tillsammans med er.
          </Text>
          <img className="robin" src="images/robin.png" alt="Robin" />
          <Button className="mail-button" onClick={mailTo}>
            Maila Robin
          </Button>
          <Button className="call-button" onClick={callTo}>
            Ring: 070 291 10 09
          </Button>
        </Flex>
      </Section>
    </>
  );
};
